// @flow

import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import { Box } from 'gestalt';

type Props = {|
  attributionNameLink?: string,
  name: string,
  regularWeight?: boolean,
|};

export default function AttributionName({ attributionNameLink, name, regularWeight }: Props) {
  const text = (
    <Text size="sm" truncate weight={regularWeight ? 'normal' : 'semibold'}>
      {name}
    </Text>
  );

  return (
    <Box>
      {attributionNameLink ? (
        <NavigateLink className="underlineLink" to={attributionNameLink}>
          {text}
        </NavigateLink>
      ) : (
        text
      )}
    </Box>
  );
}
